import { InProgress, CheckmarkFilled, ErrorFilled } from "@carbon/icons-react";
import { generateUID } from "../utils/generateUID";

export const farmListMapper = (list, t) => {
  if (!Array.isArray(list) || list.length === 0) {
    return { headers: [], rows: [] };
  }

  const orderedKeys = ["login", "created", "fuel", "state"];

  const existingKeys = orderedKeys.filter((key) =>
    key === "state" ? true : list.some((item) => item[key] !== undefined),
  );

  const headers = existingKeys.map((key) => ({
    header: `admin.tableText.main.${key}`,
    key,
  }));

  const sortedList = [...list].sort((a, b) => {
    if (a.created == null && b.created == null) return 0;
    if (a.created == null) return 1;
    if (b.created == null) return -1;
    return b.created - a.created;
  });

  return {
    headers,
    rows: sortedList.map((item) => {
      const row = {};

      row.id = String(item.id ?? generateUID());

      Object.keys(item).forEach((key) => {
        if (key === "created") {
          if (item[key] == null) {
            row[key] = "";
          } else {
            const date = new Date(item[key]);

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            const hh = String(date.getHours()).padStart(2, "0");
            const min = String(date.getMinutes()).padStart(2, "0");

            row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
          }
        } else if (key === "fuel") {
          row[key] = Math.floor(item[key]);
        } else if (key !== "state" && key !== "id") {
          row[key] = item[key];
        }
      });

      const state = item.state ?? "APPROVED";
      if (state === "APPROVED") {
        row.state = (
          <span className="indicator_cell">
            <CheckmarkFilled fill="green" />{" "}
            {t("admin.tableText.main.status.bind")}
          </span>
        );
      } else if (state === "NEW") {
        row.state = (
          <span className="indicator_cell">
            <InProgress fill="blue" />{" "}
            {t("admin.tableText.main.status.process")}
          </span>
        );
      } else {
        row.state = (
          <span className="indicator_cell">
            <ErrorFilled fill="red" />{" "}
            {t("admin.tableText.main.status.declined")}
          </span>
        );
      }
      return row;
    }),
  };
};
